// Mutations are serialized; uncertain POSTs are never automatically retried.
window.CuratedCart = (() => {
  let tail = Promise.resolve();
  let refreshVersion = 0;
  const run = task => {
    const next = tail.then(task);
    tail = next.catch(() => {});
    return next;
  };
  async function refresh() {
    const version = ++refreshVersion;
    const cartUrl = window.routes.cart_url;
    const mounts = [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
    if (document.getElementById('cart-notification-button')) mounts.push({id: 'cart-notification-button', section: 'cart-notification-button', selector: '.shopify-section'});
    if (document.querySelector('cart-drawer')) mounts.push({id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer'});
    for (const id of ['main-cart-items', 'main-cart-footer']) {
      const element = document.getElementById(id);
      if (element) mounts.push({id, section: element.dataset.id, selector: '.js-contents'});
    }
    const sections = [...new Set(mounts.map(m => m.section).filter(Boolean))];
    const read = async (url, json = true) => {
      const response = await fetch(url, {cache: 'no-store', headers: {Accept: json ? 'application/json' : 'text/html'}});
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.json();
    };
    const [cart, html] = await Promise.all([
      read(`${cartUrl}.js`),
      read(`${cartUrl}?sections=${sections.map(encodeURIComponent).join(',')}`, false),
    ]);
    if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count)) throw new Error('Invalid cart response');
    // Parse every mounted fragment before applying anything. Null sections are not success.
    const replacements = mounts.map(mount => {
      const element = document.getElementById(mount.id);
      if (!element) return null;
      const source = new DOMParser().parseFromString(html[mount.section] || '', 'text/html').querySelector(mount.selector);
      if (!source) throw new Error(`Missing cart section: ${mount.section}`);
      return {target: mount.id === 'CartDrawer' ? element : element.querySelector(mount.selector) || element, source};
    }).filter(Boolean);
    if (version !== refreshVersion) return cart;
    const focusedId = document.activeElement?.id;
    replacements.forEach(({target, source}) => { target.innerHTML = source.innerHTML; });
    if (focusedId) document.getElementById(focusedId)?.focus();
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelector('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
    const drawer = document.querySelector('cart-drawer');
    drawer?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    // Avoid a second CartItems section fetch; product quantity rules still receive full cart data.
    await publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: cart}).catch(() => {});
    return cart;
  }
  return {run, refresh};
})();
